import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  settings_type: { id: 'towingRecord.settings.type', defaultMessage: 'Type' },
  settings_station: { id: 'towingRecord.settings.station', defaultMessage: 'Station' },
  settings_operator: { id: 'towingRecord.settings.operator', defaultMessage: 'Operator' },
  settings_header: { id: 'towingRecord.settings.header', defaultMessage: 'Order settings' },
})
